module.exports = __webpack_public_path__ + "assets/a3eeab568586e591d0fc81e68672f3d2.jpg";